<template>
  <div>
    <NavTop :parentData="this.$route.params.tabBarId" class="navbar">
    </NavTop>
    <!-- 动态公告 -->
    <div class="deptNews content">
      <div class="deptNews_box">
        <div class="deptNews_box_left">
          <span>{{ title.childName }}</span>
          <span @click="goGengD(title.parentId, title.id)">查看更多</span>
        </div>
        <div class="deptNews_box_right">
          <div class="deptNews_box_right_swiper">
            <swiper class="swiper4" :options="swiperOptions4">
              <swiper-slide class="swiper_img4" v-for="(slide, index) in time" :key="index">
                <div class="swiper_img4_lefttop">
                  <span>{{ $extractDateTime(slide.createTime) }}</span>
                  <span>{{ $extractDateList(slide.createTime) }}</span>
                </div>
                <img :src="slide.url" alt="" v-if="title.appointTabId == null"
                     @click="routerpush(title.parentId,slide.tabBarId,slide.id)">
                <img :src="slide.url" alt="" v-else @click="routerpushSpan(title.appointTabId, slide.id)">
                <div class="swiper_img4_title">
                  <span>{{ slide.title }}</span>
                </div>
              </swiper-slide>
              <div class="swiper-pagination4" slot="pagination"></div>
            </swiper>
          </div>
          <div class="deptNews_box_right_list">
            <ul class="deptNews_box_right_list_ul">
              <li class="deptNews_box_right_list_ul_li" v-for="(item2,index2) in title.articleList" :key="index2">
                <span class="list_ul_li_a1" v-if="title.appointTabId == null"
                      @click="routerpush(title.parentId,item2.tabBarId,item2.id)">{{ item2.title }}</span>
                <span class="list_ul_li_a1" v-else @click="routerpushSpan(title.appointTabId, item2.id)">{{
                    item2.title
                  }}</span>
                <span class="list_ul_li_span">{{ $extractDate(item2.publishTime) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 通知公告 -->
      <div class="deptNews_tongZ">
        <div class="deptNews_tongZ_title">
          <span>{{ dept_list.childName }}</span>
          <span style="cursor: pointer" v-if="dept_list.appointTabId != null"
                @click="goTiaoZhuan(dept_list.appointTabId)">
              查看更多
            </span>
          <span style="cursor: pointer" v-else @click="goTiaoZhuanSpan(dept_list.parentId,dept_list.id)">查看更多</span>
        </div>
        <div class="deptNews_tongZ_list">
          <ul class="deptNews_tongZ_list_ul">
            <li class="deptNews_tongZ_list_ul_li" v-for="(item,index) in dept_list.articleList" :key="index">
              <span class="notice_con_list_ul_li_a" v-if="title.appointTabId == null"
                    @click="routerpush(title.parentId,item.tabBarId,item.id)">
                  {{ item.title }}</span>
              <span class="notice_con_list_ul_li_a" v-else
                    @click="routerpushSpan(title.appointTabId, item.id)">{{ item.title }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 图片 -->
    <div class="edu_pic content">
      <img style="width: 100%;height: 100%;cursor: pointer"
           src="../../assets/images/edu.png" alt>
    </div>
    <!-- 通知公告 -->
    <div class="notice">
      <div class="notice_ content">
        <div class="notice_con" v-for="(item,index) in noticeData" :key="index">
          <div class="notice_con_title">
            <span>{{ item.childName }}</span>
            <span v-if="item.appointTabId != null" @click="goTiaoZhuan(item.appointTabId)">
              查看更多
            </span>
            <span v-else @click="goTiaoZhuanSpan(item.parentId,item.id)">查看更多</span>
          </div>
          <div class="notice_con_list">
            <ul class="notice_con_list_ul">
              <li class="notice_con_list_ul_li" v-for="(item1,index1) in item.articleList" :key="index1">
                <a class="notice_con_list_ul_li_a" href="">
                  <span v-if="title.appointTabId == null" @click="routerpush(title.parentId,item1.tabBarId,item1.id)">
                  {{ item1.title }}</span>
                  <span v-else @click="routerpushSpan(title.appointTabId, item1.id)">{{ item1.title }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import home from '../../api/home'
import child from '../../api/child'

export default {
  data () {
    return {
      swiperOptions4: {
        pagination: {el: '.swiper-pagination4', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 2000
      },
      // 轮播图
      // 部门新闻列表
      title: [],
      time: [],
      dept_list: [],
      // 通知公告数据
      noticeData: [],
      // 支部建设数据
      zhibuData: [],
      // 团学活动数据
      tuanxueData: [],
      currentIndexBanner: 0 // banner轮播图
    }
  },
  mounted () {
    this.getWenZhang(this.$route.params.tabBarId)
    this.getBannerList('/edu')

  },
  methods: {

    async getBannerList (bannerPath) {
      const res = await home.getBanner({
        bannerPath
      })
      console.log(res)
      this.time = res.rows
      console.log(this.time)
    },
    navigateTo (path) {
      this.$router.push(path)
    },
    handleCarouselChange (index) {
      this.currentIndexBanner = index
    },
    async getWenZhang (tabBarId) {
      const res = await child.getChild({tabBarId: tabBarId})
      if (res.code == 200) {
        const data = res.data
        console.log(data)
        this.title = data[0]
        console.log(this.title)
        this.dept_list = data[1]
        // 通知公告数据
        this.noticeData = data.slice(2, 5)
      }
    },
    // 截取日期
    extractDate(dateTimeStr) {
      // 使用空格分割日期和时间
      if (dateTimeStr) {
        const parts = dateTimeStr.split(' ')
        // 返回日期部分
        return parts[0]
      }
    },
    extractDateTime(dateTimeStr) {
      if (dateTimeStr) {
        // 使用空格分割日期和时间
        const parts = dateTimeStr.split('-')
        const resultFen = parts[2].split(' ')
        const result = resultFen.slice(0, 1).join('-')
        // 返回日期部分
        return result
      }
    },
    extractDateList(dateTimeStr) {
      if (dateTimeStr) {
        // 使用空格分割日期和时间
        const parts = dateTimeStr.split('-')
        console.log(parts)
        const result = parts.slice(0, 2).join('-')
        // 返回日期部分
        return result
      }
    },
    goGengD (parentId, id) {
      this.$router.push({
        path: '/common/section/more' + '/' + parentId + '/' + id
      })
    },
    // 点击上方查看更多
    goTiaoZhuan (appointTabId) {
      let encodedId = encodeURIComponent(appointTabId)
      let decodedId = decodeURIComponent(encodedId)
      this.$router.push('/common/section/more' + decodedId)
    },
    goTiaoZhuanSpan (parentId, id) {
      this.$router.push('/common/section/more' + '/' + parentId + '/' + id)
    },
    routerpush (parentId, tabBarId, id) {
      this.$router.push('/common/section/detail' + '/' + parentId + '/' + tabBarId + '/' + id)
    },
    routerpushSpan (appointTabId, id) {
      let encodedId = encodeURIComponent(appointTabId)
      let decodedId = decodeURIComponent(encodedId)
      this.$router.push('/common/section/detail' + decodedId + '/' + id)
    },
  }
}
</script>
<style lang="less" scoped>
ul, li {
  list-style: none;
  color: #FFFFFF;
}

a {
  text-decoration: none !important;
}

.lunb {
  overflow: hidden;

  .lunb_con {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    transform: translateY(-125px);
    font-size: 15px;
    color: #FFFFFF;

    span {
      //transform: translateX(-20px);
    }
  }
}

.banner_carousel {
  position: relative;
}

// 部门新闻
.deptNews {
  width: 100%;
  height: 370px;
  margin-top: 20px !important;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;

  .deptNews_box {
    width: 800px;
    height: 370px;

    .deptNews_box_left {
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      span {
        &:nth-child(1) {
          font-size: 24px;
          color: #444;
          line-height: 50px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 2px;
            background: #9e070e;
          }
        }

        &:nth-child(2) {
          color: #666;
          position: relative;
          line-height: 40px;
          font-size: 14px;
          cursor: pointer;

          &:after {
            content: "";
            position: absolute;
            width: 8px;
            height: 8px;
            border: 1px solid #999;
            border-left: none;
            border-bottom: none;
            transform: rotate(45deg);
            top: 50%;
            margin-top: -5px;
            right: 7px;
          }
        }
      }
    }

    .deptNews_box_right {
      height: 280px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .deptNews_box_right_swiper {
        width: 400px;
        height: 280px;
        overflow: hidden;
        position: relative;

        .banner_carousel {
          overflow: hidden;
        }
      }

      .deptNews_box_right_list {
        width: 365px;
        height: 280px;

        .deptNews_box_right_list_ul {
          width: 100%;
          height: 100%;
          overflow: hidden;

          .deptNews_box_right_list_ul_li {
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .list_ul_li_a1 {
              display: block;
              width: 80%;
              padding-left: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-decoration: none;
              color: #444;
              font-size: 14px;
              position: relative;
              cursor: pointer;

              &:hover {
                color: #AB330E;
              }
            }

            .list_ul_li_a2 {
              width: 20px;
              height: 20px;
              display: inline-block;
              line-height: 20px;

              img {
                width: 100%;
              }
            }

            .list_ul_li_span {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }
  }

  // 通知公告
  .deptNews_tongZ {
    width: 375px;
    height: 340px;
    border: 1px solid #eee;

    .deptNews_tongZ_title {
      padding: 0 20px;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        &:nth-child(1) {
          font-size: 28px;
          color: #444;
          line-height: 54px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            background: #8d080e;
            bottom: 2px;
            left: 0;
          }
        }

        &:nth-child(2) {
          color: #666;

          &:hover {
            color: #7C2C2C;
          }
        }

      }
    }

    .deptNews_tongZ_list {
      height: 280px;
      padding: 0 20px;
      overflow: hidden;

      .deptNews_tongZ_list_ul {
        width: 100%;
        height: 100%;
        padding-top: 10px;

        .deptNews_tongZ_list_ul_li {
          height: 45px;
          padding-left: 20px;
          position: relative;
          border-bottom: 1px solid #eee;
          line-height: 45px;

          span {
            color: #333;
            display: block;
            text-decoration: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 15px;
            cursor: pointer;

            &:hover {
              color: #7c2c2c;
            }

            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #8d080e;
              border-radius: 50%;
              left: 0;
              top: 50%;
            }
          }
        }
      }
    }
  }
}

// 通知公告
.notice {
  background: #f9f9f9;
  height: 465px;

  .notice_ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 430px;

    .notice_con {
      width: 375px;
      height: 350px;
      border: 1px solid #eee;
      background: #fff;

      .notice_con_title {
        padding: 0 20px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          &:nth-child(1) {
            font-size: 24px;
            color: #444;
            line-height: 54px;
            position: relative;

            &::after {
              content: "";
              position: absolute;
              width: 100%;
              height: 2px;
              background: #8d080e;
              bottom: 2px;
              left: 0;
            }
          }

          &:nth-child(2) {
            color: #666666;
            cursor: pointer;

            &:hover {
              color: #7c2c2c;
            }
          }
        }
      }

      .notice_con_list {
        height: 280px;
        padding: 0 20px;
        overflow: hidden;

        .notice_con_list_ul {
          width: 100%;
          height: 100%;
          padding-top: 10px;

          .notice_con_list_ul_li {
            height: 45px;
            padding-left: 20px;
            position: relative;
            border-bottom: 1px solid #eee;
            line-height: 45px;
            display: flex;
            justify-content: space-around;
            align-items: center;

            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #8d080e;
              border-radius: 50%;
              left: 0;
              top: 50%;
            }

            .notice_con_list_ul_li_a {
              width: 100%;
              color: #333;
              display: block;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;

              &:hover {
                color: #7c2c2c;
              }
            }
          }
        }
      }
    }
  }
}

div {
  box-sizing: border-box !important;
}

.active {
  span {
    color: #8D0835 !important;
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}

.nav {
  &:hover {
    background-color: #9E070E;
  }
}

.dropdown_menu {
  .dropdown_menu1 {
    div {
      color: #000;

      &:hover {
        color: #fff;
      }
    }
  }
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    text-align: center;
  }

  .content {
    padding-left: 0;
  }
}

</style>
<style lang="less">
.swiper4 {
  width: 400px;
  height: 280px;
  background: #990000;
  overflow: hidden;
  position: relative;

  .swiper_img4 {
    cursor: pointer;
    position: relative;

    .swiper_img4_lefttop {
      position: absolute;
      width: 62px;
      height: 62px;
      background-color: #990000;
      top: 15px;
      left: 15px;

      span {
        &:nth-child(1) {
          display: inline-block;
          color: #fff;
          font-size: 24px;
          font-weight: bold;
          width: 62px;
          text-align: center;
          line-height: 38px;
        }

        &:nth-child(2) {
          display: inline-block;
          width: 62px;
          color: #fff;
          font-size: 14px;
          text-align: center;
        }
      }
    }

    .swiper_img4_title {
      height: 30px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.5);

      span {
        display: inline-block;
        width: 60%;
        font-size: 14px;
        overflow: hidden;
        color: #fff;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 30px;
        margin-left: 30px;
      }
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.swiper-pagination4 {
  position: absolute;
  bottom: 10px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 9999;
  width: 380px !important;
  height: 16px;

  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    border: 1px solid #fff !important;
    opacity: 1 !important;
    background: transparent !important;
    margin: 0 4px;
    box-sizing: content-box !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    margin: 0 4px;
    background: #8d080e !important;
    border: 1px solid #fff !important;
    opacity: 1 !important;
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    box-sizing: content-box !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/edu/edu.vue